/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_viewer" | "SbRespSearchResultContainer_viewer" | "SbSharedRelatedItems_viewer" | "SbRespRefineTopNav_viewer" | "SbSharedRecentlySoldItems_viewer">;
    readonly " $refType": "SbRespMainContent_viewer";
};
export type SbRespMainContent_viewer$data = SbRespMainContent_viewer;
export type SbRespMainContent_viewer$key = {
    readonly " $data"?: SbRespMainContent_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespMainContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRecentlySoldItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'c0e9550fc36c9d7c6f185c8d15493840';
export default node;
